module.exports = __webpack_public_path__ + "media/images/zoom-53e7c2ea8d95ae3a62fa237751d36861.svg";